export default function isPunchedIn(workLog) {
  return !!(workLog?.start_date && !workLog.end_date)
}
